<crm-opportunity-association-panel
  [id]="id()"
  [name]="name()"
  [objectType]="objectType()"
></crm-opportunity-association-panel>
